/**
 * Created by contrapro on 03/04/2018
 */

import { ACTION_TYPE_MESSAGE_RESULT, ACTION_TYPE_MESSAGE_ERROR } from '../actions';

const initialState = {
    messageList:[]
};

export default function messageReducer(state = initialState, action) {
    switch (action.type) {

        case ACTION_TYPE_MESSAGE_RESULT:
            //console.log('ACTION_TYPE_MESSAGE_RESULT', action.payload.msgs)
            return {
                ...state,
                messageList:action.payload.msgs
            };
        case ACTION_TYPE_MESSAGE_ERROR:
            return {
                ...state,


            };

        default:
            return { ...state };
    }
}



// WEBPACK FOOTER //
// ./src/reducers/message.js